import React from 'react';
import { useMediaQuery } from 'react-responsive';
import ContactContent from './ContactContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({
  history,
  fields,
  contactSubmit
  , handleChange,
  submitted
}) => (
  <Desktop>
    <ContactContent
      history={history}
      fields={fields}
      contactSubmit={contactSubmit}
      handleChange={handleChange}
      submitted={submitted}
    />
  </Desktop>
);

export default DesktopResponsive;
